require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-wbg-strategy-fragility-conflict-violence.json") })
        }
      }, "path---en-us-update-wbg-strategy-fragility-conflict-violence");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-wbg-strategy-fragility-conflict-violence!./.cache/json/en-us-update-wbg-strategy-fragility-conflict-violence.json
// module id = 822
// module chunks = 231608221292675